import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, toRef } from 'vue';
import { useField } from 'vee-validate';
import EInputNumber from '@common/ui/EInputNumber.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EInputNumberField',
    props: {
        name: {},
        size: {},
        id: {},
        disabled: { type: Boolean },
        readonly: { type: Boolean },
        placeholder: {},
        theme: {},
        autocomplete: { type: Boolean },
        label: {},
        tabindex: {},
        min: {},
        max: {},
        maxlength: {},
        keyFilter: { type: Function },
        inputCenter: { type: Boolean },
        autoWidth: { type: Boolean },
        mask: {},
        clearOnFocus: { type: [Boolean, Object] },
        hideError: { type: Boolean },
        position: {},
        rule: {}
    },
    emits: ["clear", "click", "focus", "paste", "keyup", "keydown", "mouseenter", "mouseleave", "input", "change"],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var eInputRef = ref();
        var handleInput = function (e) {
            emit('input', e);
            handleChangeField(e);
        };
        var handleChange = function (e) {
            emit('change', e);
            handleChangeField(e);
        };
        var name = toRef(props, 'name');
        var _b = useField(name), inputValue = _b.value, handleChangeField = _b.handleChange, handleBlur = _b.handleBlur;
        var focus = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        var blur = function () {
            var _a;
            (_a = eInputRef.value) === null || _a === void 0 ? void 0 : _a.blur();
        };
        __expose({
            focus: focus,
            blur: blur,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EInputNumber, {
                id: _ctx.id,
                "auto-width": _ctx.autoWidth,
                autocomplete: _ctx.autocomplete,
                "clear-on-focus": _ctx.clearOnFocus,
                disabled: _ctx.disabled,
                "hide-error": _ctx.hideError,
                "input-center": _ctx.inputCenter,
                "key-filter": _ctx.keyFilter,
                label: _ctx.label,
                mask: _ctx.mask,
                max: _ctx.max,
                maxlength: _ctx.maxlength,
                min: _ctx.min,
                name: name.value,
                placeholder: _ctx.placeholder,
                position: _ctx.position,
                readonly: _ctx.readonly,
                rule: _ctx.rule,
                size: _ctx.size,
                tabindex: _ctx.tabindex,
                theme: _ctx.theme,
                "model-value": _unref(inputValue),
                onBlur: _unref(handleBlur),
                onChange: handleChange,
                onClear: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('clear', $event)); }),
                onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('click', $event)); }),
                onFocus: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('focus', $event)); }),
                onInput: handleInput,
                onKeydown: _cache[3] || (_cache[3] = function ($event) { return (_ctx.$emit('keydown', $event)); }),
                onKeyup: _cache[4] || (_cache[4] = function ($event) { return (_ctx.$emit('keyup', $event)); }),
                onMouseenter: _cache[5] || (_cache[5] = function ($event) { return (_ctx.$emit('mouseenter', $event)); }),
                onMouseleave: _cache[6] || (_cache[6] = function ($event) { return (_ctx.$emit('mouseleave', $event)); }),
                onPaste: _cache[7] || (_cache[7] = function ($event) { return (_ctx.$emit('paste', $event)); })
            }, {
                append: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "append")
                ]; }),
                prepend: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "prepend")
                ]; }),
                _: 3
            }, 8, ["id", "auto-width", "autocomplete", "clear-on-focus", "disabled", "hide-error", "input-center", "key-filter", "label", "mask", "max", "maxlength", "min", "name", "placeholder", "position", "readonly", "rule", "size", "tabindex", "theme", "model-value", "onBlur"]));
        };
    }
});
